interface Props {
  message: string;
}

export function ErrorBanner({ message }: Props) {
  return (
    <div className='mb-4 px-4 py-3 rounded-xl bg-destructive/10 border border-destructive/30 text-sm text-destructive'>
      {message}
    </div>
  );
}
